module.exports = __webpack_public_path__ + "static/media/2.23_preview.b7e15235.png";